import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SaveableEntityComponent } from '../interfaces/saveable-entity';
import { PendingChangesService } from '@common/services/pending-changes.service';
import { ProjectStore } from '@frontend-site/shared/core';
import { SessionKeys, SystemTypes } from '@frontend-site/shared/data';
import { HybridMessagePayloadService } from '@frontend-site/shared/hybrid';

@Injectable()
export class PendingChangesGuard  {
    constructor(public pendingChangesService: PendingChangesService) {}
    canDeactivate(
        component: SaveableEntityComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean> {
        return this.pendingChangesService.handle(component, currentRoute, currentState, nextState);
    }
}

@Injectable()
export class RiskAnalysisGuard  {
    stateKey = 'activeState';
    stateParamsKey = 'activeStateParams';
    stateVal = ['CODE_CHANGES', 'RISK_ANALYSIS'];
    constructor(
        private router: Router,
        private projectStore: ProjectStore,
        private hybridMessagePayloadService: HybridMessagePayloadService
    ) {}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.navigateToNewRiskAnalysis(state);
    }
    navigateToNewRiskAnalysis(state: RouterStateSnapshot): boolean {
        const isSap = this.projectStore?.projectDetails?.systemType === SystemTypes.SAP;
        if (isSap) {
            const params = state.url.split('&');
            if (params.length > 1) {
                const key = params[1].split('=')[0];
                const val = params[1].split('=')[1];
                if (key === this.stateKey) {
                    switch (val) {
                        case this.stateVal[0]:
                            this.router.navigateByUrl(`${state.url.split('?')[0]}?tabName=TRANSPORTS`);
                            return false;
                            break;
                        case this.stateVal[1]:
                            let parameters: any = {};
                            if (params[2]) {
                                const keyVal = decodeURI(params[2]).split('=');
                                if (keyVal[0] === this.stateParamsKey) {
                                    parameters = JSON.parse(keyVal[1]);
                                }
                            }
                            parameters.innerTabName = 'ImpactedEntryPoints';
                            this.hybridMessagePayloadService.sessionSet(parameters, SessionKeys.EP_TEST);
                            this.router.navigateByUrl(`${state.url.split('?')[0]}?tabName=TESTING`);
                            return false;
                            break;
                    }
                }
            }
        }
        return true;
    }
}
